var exports = {
  "kL": "x93eb46d8--8510f9--container",
  "$h": "x93eb46d8--8510f9--closed",
  "Qs": "x93eb46d8--8510f9--content",
  "VG": "x93eb46d8--8510f9--title-block",
  "DD": "x93eb46d8--8510f9--title",
  "c5": "x93eb46d8--8510f9--arrow-wrapper",
};

module.exports = exports;
